module.exports = __webpack_public_path__ + "img/SHAP.9cf72e43.png";